import { render, staticRenderFns } from "./ProductWideCard.vue?vue&type=template&id=36e6eb14"
import script from "./ProductWideCard.vue?vue&type=script&lang=js"
export * from "./ProductWideCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlusIcon: require('/vercel/path0/components/icons/PlusIcon.vue').default})
